import { BROKER_LINKS } from "@/data/brokers";
type BrokerSpec = {
  label: string;
  value: string;
  valueClass: string;
};

type Broker = {
  name: string;
  initial: string;
  logoClass: string;
  regulation: string;
  featured: boolean;
  specs: BrokerSpec[];
};

const BROKERS: Broker[] = [
  {
    name: 'IC Markets',
    initial: 'IC',
    logoClass: 'bg-slate-900',
    regulation: 'ASIC · CySEC · SCB',
    featured: false,
    specs: [
      { label: 'Nền tảng', value: 'MT4 / MT5 / cTrader', valueClass: 'text-slate-800' },
      { label: 'Spread tối thiểu', value: 'Từ 0.0 pip', valueClass: 'text-purple-600' },
      { label: 'Commission', value: '$7 / lot', valueClass: 'text-slate-800' },
      { label: 'Đòn bẩy tối đa', value: '1:500', valueClass: 'text-slate-800' },
    ],
  },
  {
    name: 'FxPro',
    initial: 'EX',
    logoClass: 'bg-emerald-600',
    regulation: 'FCA · CySEC · FSCA',
    featured: true,
    specs: [
      { label: 'Nền tảng', value: 'MT4 / MT5', valueClass: 'text-slate-800' },
      { label: 'Spread tối thiểu', value: 'Từ 0.0 pip', valueClass: 'text-purple-600' },
      { label: 'Commission', value: 'Không (Miễn phí)', valueClass: 'text-emerald-600' },
      { label: 'Đòn bẩy tối đa', value: '1:1:500', valueClass: 'text-purple-600' },
    ],
  },
  {
    name: 'XM',
    initial: 'XM',
    logoClass: 'bg-amber-600',
    regulation: 'ASIC · CySEC · FSC',
    featured: false,
    specs: [
      { label: 'Nền tảng', value: 'MT4 / MT5', valueClass: 'text-slate-800' },
      { label: 'Spread tối thiểu', value: 'Từ 0.6 pip', valueClass: 'text-slate-800' },
      { label: 'Commission', value: 'Không', valueClass: 'text-slate-800' },
      { label: 'Đòn bẩy tối đa', value: '1:1000', valueClass: 'text-slate-800' },
    ],
  },
];

export default function BrokerSection() {
  return (
    <section className="mx-auto max-w-6xl px-4 py-16">
      <div className="mb-12 text-center">
        <p className="mb-3 text-xs font-bold uppercase tracking-widest text-purple-600">
          Điều kiện giao dịch
        </p>
        <h2 className="mb-4 font-display text-2xl font-extrabold text-slate-900 lg:text-3xl">
          So sánh điều kiện môi giới hàng đầu
        </h2>
        <p className="mx-auto max-w-xl text-sm text-slate-500">
          Lựa chọn sàn giao dịch tối ưu với Spread thấp, đòn bẩy linh hoạt và độ uy tín cao.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {BROKERS.map((b) => (
          <div
            key={b.name}
            className={`group relative flex flex-col justify-between rounded-3xl p-8 transition-all ${
              b.featured
                ? 'border-2 border-purple-600 bg-white shadow-md shadow-purple-500/5 hover:shadow-lg'
                : 'border border-slate-200/80 bg-white shadow-sm hover:border-purple-300 hover:shadow-md'
            }`}
          >
            {b.featured && (
              <span className="absolute -top-3.5 right-6 rounded-full bg-purple-600 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-white">
                ⚡ Đề xuất số 1
              </span>
            )}

            <div>
              <div className="mb-6 flex items-center gap-3">
                <span
                  className={`flex h-12 w-12 items-center justify-center rounded-2xl text-lg font-bold text-white shadow-sm ${b.logoClass}`}
                >
                  {b.initial}
                </span>
                <div>
                  <p className="text-lg font-extrabold text-slate-900">{b.name}</p>
                  <p className="text-[11px] text-slate-400">{b.regulation}</p>
                </div>
              </div>

              <div className="mb-8 space-y-3 border-y border-slate-100 py-4 text-xs">
                {b.specs.map((s) => (
                  <div key={s.label} className="flex justify-between">
                    <span className="text-slate-400">{s.label}</span>
                    <span className={`font-bold ${s.valueClass}`}>{s.value}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="w-full">
              <a href={BROKER_LINKS[b.name]||'#'}
                className="block w-full text-center whitespace-nowrap rounded-xl bg-purple-600 py-2.5 text-xs font-bold text-white shadow-sm transition-all hover:bg-purple-700"
              >
                Mở tài khoản
              </a>
            </div>
          </div>
        ))}
      </div>

      <p className="mx-auto mt-12 max-w-4xl text-center text-[11px] leading-relaxed text-slate-400">
        Công cụ này chỉ nhằm mục đích cung cấp thông tin và mô phỏng toán học. Kết quả có thể thay đổi tùy thuộc vào thị trường,
        Spread, Commission, Swap và điều kiện giao dịch thực tế.
      </p>
    </section>
  );
}